export const DEFAULT_OBJECT_TYPE = 'flat_old,flat_new';
